import React from 'react';
import { Card, Button} from 'react-bootstrap';

const HTML = () => (
    <div className="html-div">
        <Card className="card-box">
            <Card.Img className="card-img" variant="top" src="/images/Techdegree-project-1-screenshot.png" />
            <Card.Body>
            <Card.Title>My First Project</Card.Title>
            <Card.Text>
                    This was the first project that I’ve ever worked on. It’s not much, all I added 
                was a little bit of HTML that I learned in the beginning of my course. I keep it 
                as a memory of how far I have gotten from the beginning of my programming journey. 
                It is an eye opener of how far I’ve come, and this will help motivate me to continue 
                my journey to becoming a professional software developer.
            </Card.Text>
            <Button href="https://ramces14.github.io/Techdegree-project-1/">Enter</Button>
            </Card.Body>
        </Card>
    </div>
);

export default HTML;